export default function getResource(label) {
    const resources = {
        joinNow: 'Join Now',
        createAccount: 'Create Account',
        signIn: 'Sign In',
        signUpInStore: 'You can also sign up in store! Just show your friend’s referral to get 10% off your purchase of $25 or more.'
    };

    return resources[label];
}
